import { render, staticRenderFns } from "./zonghe.vue?vue&type=template&id=1b0b9c90&scoped=true&"
import script from "./zonghe.vue?vue&type=script&lang=js&"
export * from "./zonghe.vue?vue&type=script&lang=js&"
import style0 from "./zonghe.vue?vue&type=style&index=0&id=1b0b9c90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0b9c90",
  null
  
)

export default component.exports